import { Fragment, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { IconButton } from "@rg/ui/components/IconButton";
import CloseIcon from "@/common/images/icons/cross.svg?react";

import classes from "./UploadHeader.module.scss";

export const UploadHeader = () => {
  const navigate = useNavigate();

  const handleClose = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <Fragment>
      <p className={classes.navUpload}>Upload</p>
      <IconButton
        icon={<CloseIcon />}
        onClick={handleClose}
        variant="secondary"
        size="sm"
        aria-label="close upload form"
      />
    </Fragment>
  );
};
